import React, { MouseEventHandler, type ReactElement } from 'react';
import { noop } from 'lodash';
import { BaseContainerComponentPropsType } from '../../util/types';
import { makeClassName } from '@siteless/util';

const Action = ({
  onClick = noop,
  disabled = false,
  disablePadding = false,
  children,
  Icon,
  className,
  stacked,
}: BaseContainerComponentPropsType & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  disablePadding?: boolean;
  stacked?: boolean;
  Icon?: ({
    className,
  }: {
    [x: string]: any;
    className?: string;
  }) => ReactElement;
}) => {
  let handleClick = React.useCallback<MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      if (disabled) return;
      onClick(event);
    },
    [onClick, disabled],
  );

  return (
    <button
      className={makeClassName(
        'Action',
        !disablePadding && 'py-2 px-4',
        stacked && '--stacked',
        disabled ? 'cursor-not-allowed' : 'cursor-pointer',
        className,
      )}
      onClick={handleClick}
      disabled={disabled}
    >
      {Icon && <Icon className="__icon mr-3 flex-none last:mr-0" />}
      {Boolean(children) && <span className="__body">{children}</span>}
    </button>
  );
};

export default Action;
